import { createSelector } from 'reselect'

export const getSmsCodeVerified = createSelector(
  state => Boolean(state && state.common && state.common.form && state.common.form.smsCodeVerified),
  smsCodeVerified => smsCodeVerified
)
